export const Selection = {
    Motorcycle: 16,
    Personal: 17,
    Utility: 18,
    Offroad: 19,
    Trailer: 51,
    SemiTrailer: 53,
    TricycleQuadBike: 67,
    TruckOver35t: 72,
    TractorWithRegistrationMark: 73,
    TractorWithoutRegistrationMark: 74,
    CamperVehicle: 149,
    Tahac: 150,
    WorkMachine: 151,
    WorkMachineNoRegistration: 152,
    OtherNonregistered: 1065,
    NormalUsage: 20,
    Petrol: 26,
    Diesel: 27,
    Gas: 28,
    None: 52,
    Electricity: 57,
    OtherFuelType: 601,
    HybridBE: 799,
    HybridDE: 800,
    PermanentlyUnallocated: 206,
    VehicleOriginCzech: 24,
    VehicleOriginForeign: 25,
    Person: 29,
    Company: 30,
    SelfEmployed: 55,
    Yearly: 32,
    HalfYearly: 33,
    Quarterly: 34,
    Monthly: 71,
    OneTime: 701,
    Bank: 35,
    Inkaso: 36,
    PostalOrder: 37,
    SIPO: 38,
    Eletricity: 57,
    Imobilizer: 58,
    GlassMarking: 60,
    GearLevelLock: 61,
    PassiveSearch: 62,
    ActiveSearch: 63,
    AutomaticTransmissionLock: 64,
    Invoice: 68,
    VehicleValuation: 69,
    AccordingPolicyHolder: 70,
    SklepPlocha13: 82,
    SklepPlocha23: 83,
    SklepPlocha33: 84,
    ProvedeniBudovaZaklad: 92,
    ProvedeniBudovaStandard: 93,
    ProvedeniBudovaLuxus: 94,
    StrechaPlocha: 95,
    StrechaSedlova: 96,
    RodinnyDum: 110,
    Byt: 111,
    NajemniByt: 112,
    RekreacniObjekt: 113,
    StructuralTypeBrick: 114,
    StructuralTypeWooden: 115,
    StructuralTypeMixed: 116,
    StavbaDokoncena: 117,
    StavbaVRekonstrukci: 118,
    StavbaVeVystavbe: 119,
    VlastnictviOsobni: 120,
    VlastnictviDruzstevni: 121,
    BytTypovy: 122,
    BytNetypovy: 123,
    Vlastnik: 124,
    Spoluvlastnik: 125,
    Najemce: 126,
    Pronajimatel: 806,
    Jiny: 127,
    RekonstrukcePrubezna: 128,
    RekonstrukceCelkova: 129,
    RekonstrukceZadna: 130,
    VybaveniDomacnostZaklad: 100,
    VybaveniDomacnostStandard: 101,
    VybaveniDomacnostLuxus: 102,
    Altanek: 103,
    Dilna: 104,
    Garaz: 105,
    HospBudova: 106,
    Sklep: 107,
    Komora: 108,
    Bazen: 131,
    Jina: 109,
    PersonSameAsPolicyHolder: 142,
    PersonSameAsOwner: 143,
    PersonSameAsKeeper: 144,
    PersonSameAsClient: 744,
    Signature: 153,
    Payment: 154,
    TerritorialValidityEurope: 210,
    TerritorialValidityCzech: 211,
    RelationInsurerToPolicyHolderOther: 514,
    AutTransmission: 747,
    FourWheelDrive: 748,
    ParkingAssistant: 759,
    MakeModelIdTypeUCL: 767,
    MakeModelIdTypeCebia: 768,
    TravelDestinationEurope: 930,
    TravelDestinationWorldWithoutNorthAmerica: 931,
    TravelDestinationWorld: 932,
    TravelDestinationCzech: 933,
    TravelTypeShort: 934,
    TravelTypeYearly: 935,
    TravelTypeRepeated: 936,
    TravelReasonStayTrip: 937,
    TravelReasonCognitive: 938,
    TravelReasonBusiness: 939,
    TravelReasonManualWork: 940,
    TravelSportRecreational: 941,
    TravelSportWinter: 942,
    TravelSportRisky: 943,
    OverpaymentTypeNewInsurance: 1084,
    OverpaymentTypePerPost: 1085,
    OverpaymentTypeBankTransfer: 1086,
    DigitalSignatureTypeLocal: 1091,
    DigitalSignatureTypeRemote: 1092,
} as const;

export type Selection = typeof Selection[keyof typeof Selection];

export default Selection